export const baseURL = (process.env.NODE_ENV === 'production' ? '' : 'http://new.moto.wer.org.ua.localhost') + '/v1/';

export default {
   baseURL,
};
